import React, { useEffect } from "react";
import { Box, Stack, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import LandingLayout from "../../../layout/LandingLayout";
import { colors, theme } from "../../../theme/theme";
import { getAboutMe } from "../../../redux/dispatchers/aboutMe.dispatcher";

const LandingAboutMe = () => {
  const dispatch = useDispatch();
  const { aboutMe } = useSelector((state) => state.aboutMe);

  useEffect(() => {
    dispatch(getAboutMe());
  }, [dispatch]);

  if (!aboutMe) {
    return (
      <LandingLayout>
        <Typography
          sx={{
            color: "rgba(255,255,255,0.6)",
            fontFamily: "Mulish-Regular",
            fontSize: "14px",
          }}
        >
          Nothing to show yet.
        </Typography>
      </LandingLayout>
    );
  }

  return (
    <LandingLayout>
      <Box
        sx={{
          borderRadius: "18px",
          overflow: "hidden",
          border: theme.lightBorder,
          p: { xs: 3, md: 5 },
        }}
      >
        <Stack
          direction={{ xs: "column", md: "row" }}
          spacing={4}
          alignItems={{ xs: "flex-start", md: "center" }}
        >
          <Box
            component="img"
            src={aboutMe.photo_url}
            alt={aboutMe.name}
            sx={{
              width: { xs: "120px", md: "160px" },
              height: { xs: "120px", md: "160px" },
              borderRadius: "50%",
              objectFit: "cover",
              border: `2px solid ${colors.secondary}`,
            }}
          />
          <Box>
            <Typography
              sx={{
                color: "#fff",
                fontFamily: "Mulish-ExtraBold",
                fontSize: { xs: "26px", md: "32px" },
                mb: 1,
              }}
            >
              {aboutMe.name}
            </Typography>
            <Typography
              sx={{
                color: colors.secondary,
                fontFamily: "Mulish-SemiBold",
                fontSize: "14px",
              }}
            >
              {aboutMe.tagline}
            </Typography>
          </Box>
        </Stack>

        <Typography
          sx={{
            color: "rgba(255,255,255,0.75)",
            fontFamily: "Mulish-Regular",
            fontSize: "15px",
            lineHeight: 1.7,
            mt: 4,
          }}
        >
          {aboutMe.bio}
        </Typography>
      </Box>
    </LandingLayout>
  );
};

export default LandingAboutMe;
